import React from 'react';
import { useMarkingContext } from '../MarkingContext/MarkingContext';
import InfoCurrentPeriodicalReport from '../../InfoCurrentPeriodicalReport/InfoCurrentPeriodicalReport';

const InforMarking = () => {
  const { isLoading, currentPeriodicalReport } = useMarkingContext();
  return (
    <InfoCurrentPeriodicalReport isLoading={isLoading} currentPeriodicalReport={currentPeriodicalReport} />
  );
};

export default InforMarking;
